export default {
  state: {
    weddingInfos: {},
    modalState: false,
  },

  mutations: {
    SET_WEDDING_INFO(state, payload) {
      state.weddingInfos = payload
    },
    SET_OPEN_MODAL(state, payload) {
      state.modalState = payload
    },
  },

  actions: {
    setWeddingInfo(context, payload) {
      context.commit('SET_WEDDING_INFO', payload)
    },
    setOpenModal(context, payload) {
      context.commit('SET_OPEN_MODAL', payload)
    },
  },
}
